"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canUseRoot = exports.canUseDOM = void 0;
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
exports.canUseDOM = canUseDOM;

var canUseRoot = function canUseRoot(root) {
  return !!root;
};

exports.canUseRoot = canUseRoot;